var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 1.44,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n                .cls-1 {\n                    fill: none;\n                    stroke: #1c6f97;\n                    stroke-linecap: round;\n                    stroke-linejoin: round;\n                }\n            ")), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.45,5.5a2,2,0,0,0-1.95,2v33.1a2,2,0,0,0,2,2h33.1a2,2,0,0,0,2-2V7.45a2,2,0,0,0-2-1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.09,30V18h2a6,6,0,0,1,6,6h0a6,6,0,0,1-6,6Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 32.48,
    y1: 18.04,
    x2: 38.46,
    y2: 18.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 32.48,
    y1: 24.02,
    x2: 36.38,
    y2: 24.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 32.48,
    y1: 18.04,
    x2: 32.48,
    y2: 30
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.54,30V18h4a4,4,0,0,1,0,8h-4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdf);
export default __webpack_public_path__ + "static/media/icon_pdf.c1996990576ca23d557dd20db792ae21.svg";
export { ForwardRef as ReactComponent };